module.exports = __webpack_public_path__ + "media/images/athletes/2142-ae72df699cc19cdb7031d8e0cc9013c9.png";